import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchProviderLocations = createAsyncThunk(
  "fetchProviderLocations",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/locations`
    );
    return result;
  }
);

export const fetchUpdateProviderLocationStatus = createAsyncThunk(
  "fetchUpdateProviderLocationStatus",
  async ({ providerId, locationId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/practices/${locationId}/status`,
      data
    );
    return result;
  }
);
